
import apiRequest from "./apiRequest";

export const mgt2Api = {
 fetchMgt2Register: (accountId, token) => {
    return apiRequest(`/api/register/mgt2?accountId=${accountId}`, 'GET', token);
  },
  
 
  fetchMgt2ShareSummary: (accountId, token) => {
    return apiRequest(
      `/api/register/mgt2/share-summary?accountId=${accountId}`,
      "GET",
      token
    );
  },


  addNewDebentureHolding: (mgt2Id, payload, token) => {
    return apiRequest(
      `/api/register/mgt2/add-new/debenture-holding?mgt2Id=${mgt2Id}`,
      "POST",
      token,
      payload         
    );
  },

  submitMgt2Form: (formData, accountId, token) => {
    return apiRequest(`/api/register/mgt2?accountId=${accountId}`, 'POST', token, formData);
  },

  
};